import { createContext, useCallback, useState } from 'react';
import { Color } from '@material-ui/lab/Alert';
import { wrap } from '@hilma/tools';

export const IsAlertOpenContext = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>] | null>(null);
export const AlertTextContext = createContext<[string, React.Dispatch<React.SetStateAction<string>>] | null>(null);
export const AlertTypeContext = createContext<[Color, React.Dispatch<React.SetStateAction<Color>>] | null>(null);
export const AlertContext = createContext<((text: string, type?: Color) => void) | null>(null);

const AlertProvider: React.FC = ({ children }) => {
	const isOpenTuple = useState(false), [, setIsOpen] = isOpenTuple;
	const textTuple = useState(''), [, setText] = textTuple;
	const typeTuple = useState<Color>('error'), [, setType] = typeTuple;

	const alert = useCallback((text: string, type: Color = 'error') => {
		setIsOpen(true);
		setText(text);
		setType(type);
	}, []);

	return wrap(
		[IsAlertOpenContext.Provider, { value: isOpenTuple }],
		[AlertTextContext.Provider, { value: textTuple }],
		[AlertTypeContext.Provider, { value: typeTuple }],
		[AlertContext.Provider, { value: alert }]
	)(children) as React.ReactElement;
}

export default AlertProvider;